module.exports = __webpack_public_path__ + "static/media/blood-flag.da7d4daa.svg";